import { axios } from 'configs'
import type {
  TCreateOaCreationJobRequest,
  TListOaCreationJobsResponse,
  TOaCreationJob,
} from 'types'

const BASE = '/admin/oa-creation-jobs'

export const listOaCreationJobs = async (params: {
  currentPage?: number
  pageSize?: number
}): Promise<TListOaCreationJobsResponse> => {
  const response = await axios.get<TListOaCreationJobsResponse>(BASE, {
    params,
  })
  return response.data
}

export const getOaCreationJob = async (
  jobId: number,
): Promise<TOaCreationJob> => {
  const response = await axios.get<TOaCreationJob>(`${BASE}/${jobId}`)
  return response.data
}

export const createOaCreationJob = async (
  request: TCreateOaCreationJobRequest,
): Promise<TOaCreationJob> => {
  const response = await axios.post<TOaCreationJob>(BASE, request)
  return response.data
}
